import { NgxLoggerLevel } from 'ngx-logger';

export const ownerEnvironment = {
  production: false,
  apiUrl: 'http://localhost:4200/',
  enableMedicalRecordsV2: true,

  development: isLocalhostConfiguration(),
  logger: {
    level: NgxLoggerLevel.DEBUG,
    serverLogLevel: NgxLoggerLevel.ERROR,
    disableConsoleLogging: false,
  },
};

function isLocalhostConfiguration() {
  return window.location.href.includes('localhost');
}
